





















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class NotAvailable extends Vue {
  @Prop({ default: "" })
  readonly name!: any;
  @Prop({ default: null })
  readonly oportunity!: any;
  @Prop({ default: "" })
  readonly imageContent!: string;
  @Prop({ default: "" })
  readonly notAvailableImageContent!: string;

}
